import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import { lightThemeColors } from "../../assets/styles/colors";
import CustomInput from "./CustomInput";
import CustomBigSubmitButton from "./CustomBigSubmitButton";
import { useNavigate } from "react-router-dom";
import {
  isEmailValid,
  isNameValid,
  isPasswordValid,
  passwordsMatch,
} from "../../helper/ValidatorsHelper";
import { useUserContext } from "../../context/useUserContext";
import { showErrorNotification, showGenericError } from "../../helper/Notifications";
import ReactPasswordChecklist from "react-password-checklist";
import { ReactComponent as HideIcon } from "../../assets/icons/generic/eyeClosed.svg"
import { ReactComponent as ShowIcon } from "../../assets/icons/generic/eyeOpen.svg"

const Registercard = ({ setIsLoading }) => {
  const { createUser } = useUserContext();
  const navigate = useNavigate();
  const initialValues = {
    name: "",
    email: "",
    password: "",
    password_confirm: "",
  };

  const [inputValues, setInputvalues] = useState(initialValues);
  const [emailValid, setEmailValid] = useState(true);
  const [nameValid, setNameValid] = useState(true);
  const [passwordValid, setPasswordValid] = useState(true);
  const [samePasswords, setSamePasswords] = useState(true);
  const [registerEnabled, setRegisterEnabled] = useState(false);
  const [passwordRulesValid, setPasswordRulesValid] = useState(false)
  const [showConditions, setShowConditions] = useState(false);
  const [passFiedlType, setPassFieldType] = useState("password")
  const [passConfirmFiedlType, setPassConfirmFieldType] = useState("password")

  const handleShowPassword = () => {
    if (passFiedlType === "password") {
      setPassFieldType("text")
    } else {
      setPassFieldType("password")
    }

  }

  const handleShowPasswordConf = () => {
    if (passConfirmFiedlType === "password") {
      setPassConfirmFieldType("text")
    } else {
      setPassConfirmFieldType("password")
    }

  }

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setInputvalues({
      ...inputValues,
      [name]: value,
    });
  };

  const handleSignInBtn = () => {
    if (!isNameValid(inputValues.name)) {
      setNameValid(false);
    } else {
      setNameValid(true);
    }

    if (!isEmailValid(inputValues.email)) {
      setEmailValid(false);
      // return;
    } else {
      setEmailValid(true);
    }

    if (!isPasswordValid(inputValues.password)) {
      setPasswordValid(false);
      // return;
    } else {
      setPasswordValid(true);
    }

    if (!passwordRulesValid) {
      setShowConditions(true);
      return
    }

    if (
      isNameValid(inputValues.name) &&
      isEmailValid(inputValues.email) &&
      passwordRulesValid
    ) {
      setIsLoading(true);
      createUser(
        inputValues.email,
        inputValues.password,
        inputValues.name,
        (response) => {
          // User created
          setIsLoading(false);
          navigate("/");
        },
        () => {
          setIsLoading(false);
          showGenericError();
        }
      );
    }
  };

  const goToLogin = () => {
    navigate("/login");
  };

  useEffect(() => {
    if (
      isEmailValid(inputValues.email) &&
      isNameValid(inputValues.name) &&
      inputValues.password.length > 7 &&
      inputValues.password_confirm.length > 7
    ) {
      setRegisterEnabled(true);
    } else {
      setRegisterEnabled(false);
    }
  }, [inputValues]);

  return (
    <Card>
      <TitleContainer>
        <h2>Create your account</h2>
      </TitleContainer>
      <InputsWrapper>
        <CustomInput
          label={"Name"}
          placeholder="Enter your name "
          name={"name"}
          value={inputValues.name}
          onChange={handleInputChange}
          error={!nameValid}
          errorText={"Name must be at least 3 characters"}
        />
        <CustomInput
          label={"Email"}
          placeholder="Enter your e-mail adress"
          name={"email"}
          value={inputValues.email}
          onChange={handleInputChange}
          error={!emailValid}
          errorText={"Invalid email"}
        />

        <CustomInput
          label={"Create Password"}
          placeholder="Enter your password"
          name={"password"}
          value={inputValues.password}
          onChange={handleInputChange}
          type={passFiedlType}
          customButton={
            <ShowPasswordBtn onClick={() => handleShowPassword()}>
              {passFiedlType == "password" ?
                <HideIcon />
                :
                <ShowIcon />
              }
            </ShowPasswordBtn>
          }
        />

        <CustomInput
          label={"Confirm Password"}
          placeholder="Confirm your password"
          name={"password_confirm"}
          type={passConfirmFiedlType}
          value={inputValues.password_confirm}
          onChange={handleInputChange}
          customButton={
            <ShowPasswordBtn onClick={() => handleShowPasswordConf()}>
              {passConfirmFiedlType == "password" ?
                <HideIcon />
                :
                <ShowIcon />
              }
            </ShowPasswordBtn>
          }
        />

        <div style={showConditions ? { display: "flex" } : { display: "none" }}>
          <ReactPasswordChecklist
            iconSize={14}
            minLength={8}
            value={inputValues.password}
            valueAgain={inputValues.password_confirm}
            rules={["minLength", "specialChar", "capital", "lowercase", "number", "match"]}
            onChange={(isValid) => { setPasswordRulesValid(isValid) }}
            className="password-rules"
          />

        </div>
      </InputsWrapper>

      <SbmitWrapper>
        <CustomBigSubmitButton
          text={"Get started"}
          onClick={handleSignInBtn}
          disabled={!registerEnabled}
        />
        <p>
          Already a member? <span onClick={() => goToLogin()}>Sign in</span>
        </p>
      </SbmitWrapper>
    </Card>
  );
};

export default Registercard;

const Card = styled.div`
  display: flex;
  flex-direction: column;
  padding: 50px;
  align-items: center;
  min-width: 530px;
  background: ${lightThemeColors.background};
  min-height: 700px;
  gap: 35px;
  border-radius: 10px;
  margin-left: auto;
  margin-right: auto;
  box-shadow: 0px 0px 40px 0px rgba(151, 168, 190, 0.2);
  z-index: 1;
    @media(max-width:650px){
  width:100%;
  min-width: unset;
  }
`;
const TitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  gap: 20px;
  width: 100%;
  h1 {
    color: ${lightThemeColors.darkColorFaded};
    font-weight: 900;
    font-size: 25px;
  }
  h2 {
    color: ${lightThemeColors.darkColorFaded};
    font-weight: 700;
    font-size: 25px;
    line-height: 38px;
  }
`;
const InputsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
  width: 100%;
  .password-rules{
  
  span{

   color: ${lightThemeColors.darkColorFaded};
    font-size: 16px;
    font-weight: 400;
    line-height: 22px;
    text-align: left;
  }
  
  }
`;

const SbmitWrapper = styled.div`
  margin-top: auto;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
  p {
    color: ${lightThemeColors.darkColorFaded};
    font-size: 16px;
    font-weight: 400;
    line-height: 30px;
    text-align: left;
  }
  span {
    margin-left: 4px;
    font-weight: 700;
    color: ${lightThemeColors.primaryColor};
    cursor: pointer;
  }
`;

const ShowPasswordBtn = styled.button`
border:none;
background:none;
cursor:pointer;
display:flex;
align-items:center;
jutify-content:center;
svg{
width:16px;
height:16px;
color:${lightThemeColors.inputSubtitleColor}
}
`